import http, { CancelToken } from './http';
import notifier from '../_utils/notifier';
import { SubmissionError } from 'redux-form';
import { SHOP_TYPES } from '../config';

export let cancelRequest = undefined;

const userAPI = {
  getUserData(userSlug) {
    return http.get('users/' + userSlug + '/', {
      headers: {
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': '0',
      }
    })
    .then(
      function(success) { return success },
      function(error) {
        notifier.alert(gettext('При загрузке страницы произошла ошибка. ') + '<br>' + error.messages);
      }
    )
  },

  updateUserData(payload) {
    return http.patch('users/update/',{ ...payload })
    .then(
      function(success) { return success },
      function(error) {
        throw new SubmissionError( error.messages[0]);
      }
    )
  },

  deleteUserPhoto() {
    return http.delete('users/photo/')
    .then(
      function(success) { return 'ok' },
      function(error) {
        notifier.alert(gettext('При удалении фотографии произошла ошибка. ') + '<br>' + error.messages);
      }
    )
  },

  uploadUserPhoto(payload) {
    return http.post('users/photo/',
      payload,
      { headers: { 'Content-Type': 'multipart/form-data' } })
    .then(
      function(success) { return success },
      function(error) {
        notifier.alert(gettext('При загрузке фотографии произошла ошибка. ') + '<br>' + error.messages);
      }
    )
  },

  getNotifications() {
    return http.get('users/notifications/')
    .then(
      function(success) { return success },
      function(error) {
        notifier.alert(gettext('При загрузке страницы произошла ошибка. ') + '<br>' + error.messages);
      }
    )
  },

  makeReadNotifications(ids){
    let source = CancelToken.source();
    return http.put('users/notifications/',
      { record: ids },
      { cancelToken: new CancelToken(function executor(c) {cancelRequest = c;})}
    )
    .then(
      function(success) { return success },
      function(error) { }
    )
  },

  userLogin(payload) {
    return http.post('users/login/', payload)
    .then(
      function(success) { return success },
      function(error) {
        throw new SubmissionError( { _error:  error.messages[0]['__all__'] })
      }
    )
  },

  validate(data){
    return http.post('users/validate/', data)
    .then(
      function(success) { return success },
      function(error) {
        throw new Error(error.messages);
      }
    )
  },

  changePassword(payload) {
    return http.patch('users/change-password/',{ ...payload })
    .then(
      function(success) { return success },
      function(error) {
        throw new SubmissionError( error.messages[0]);
      }
    )
  },

  getPaymentDataMethods() {
    return http.get('users/payment-data-methods/')
    .then(
      function(success) { return success },
      function(error) {
        notifier.alert(gettext('При загрузке данных произошла ошибка. ') + '<br>' + error.messages);
      }
    );
  },

  getPaymentDataList() {
    return http.get('users/payment-data/', {
      headers: {
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': '0',
      }
    })
    .then(
      function(success) { return success },
      function(error) {
        notifier.alert(gettext('При загрузке страницы произошла ошибка. ') + '<br>' + error.messages);
      }
    )
  },

  createPaymentData(payload) {
    return http.post('users/payment-data/', payload)
    .then(
      function(success) { return success },
      function(error) {
        notifier.alert(gettext('При сохранении данных произошла ошибка. ') + '<br>' + error.messages);
      }
    )
  },

  deletePaymentData(id){
    return http.delete(`users/payment-data/${id}/`)
    .then(
      function(success) { return 'ok'; },
      function(error) {
        notifier.alert(gettext('При удалении данных произошла ошибка. ') + '<br>' + error.messages);
      }
    )
  },

  getPaymentData(id) {
    return http.get(`users/payment-data/${id}/`)
    .then(
      function(success) { return success },
      function(error) {
        notifier.alert(gettext('При загрузке страницы произошла ошибка. ') + '<br>' + error.messages);
        throw new Error(error.messages);
      }
    );
  },

  updatePaymentData(id, payload) {
    return http.patch(`users/payment-data/${id}/`,{ ...payload })
    .then(
      function(success) { return success },
      function(error) {
        throw new SubmissionError( error.messages[0]);
      }
    )
  },

};


export default userAPI;

